import Tooltip from '@mui/material/Tooltip';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { CampaignType } from 'domain/campaign/CampaignType';
import {
	UnitAvatar,
	UnitAvatarProps,
} from 'modules/UnitOverview/UnitInformation/Components/UnitAvatar';

import { CampaignBadge } from './CampaignBadge';

export interface AvatarWithCampaignProps {
	campaignType?: CampaignType | null;
}

const AvatarWithCampaign = memo(
	({
		campaignType,
		imageId,
		withZoom,
	}: AvatarWithCampaignProps & UnitAvatarProps): React.JSX.Element => {
		const { t } = useTranslation(['unitOverview']);
		return (
			<CampaignBadge campaignType={campaignType}>
				<Tooltip title={t('unitOverview:unit-avatar-tooltip')} arrow>
					<span>
						<UnitAvatar
							imageId={imageId}
							thumbnail
							withZoom={withZoom}
						/>
					</span>
				</Tooltip>
			</CampaignBadge>
		);
	}
);

export default AvatarWithCampaign;
